import { render, staticRenderFns } from "./SustainabilityDataEntry.vue?vue&type=template&id=991a3142&scoped=true&"
import script from "./SustainabilityDataEntry.vue?vue&type=script&lang=js&"
export * from "./SustainabilityDataEntry.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityDataEntry.vue?vue&type=style&index=0&id=991a3142&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991a3142",
  null
  
)

export default component.exports